import { IOffer, ConfigField } from '../../../../../types';
import { ApplicationState } from '../../../../../store';

type Fields = Pick<IOffer, 'courses'>;

export type Visible = Record<'offerEvidence', boolean>;

export type Mandatory = Record<'offerEvidence', boolean>;

export function getPageStatus(
  config: ApplicationState['config'],
  fields: Fields
): {
  complete: boolean;
  visible: Visible;
  mandatory: Mandatory;
} {
  const { courses } = fields;

  const {
    OfferEvidence: offerEvidenceConfig
  }: {
    OfferEvidence: ConfigField;
  } = config.Checklist.PersonalInfo.Page5_1;

  const visible: Visible = {
    offerEvidence: offerEvidenceConfig?.visible
  };

  const mandatory: Mandatory = {
    offerEvidence: offerEvidenceConfig?.mandatory
  };

  const isCourseComplete = (): boolean => {
    let isComplete = true;
    if (!courses || courses!.length === 0) {
      return false;
    }
    const parsedCourses = courses.filter(
      course => course && course.courseName !== '' && course.courseName !== undefined && course.offerEvidence !== ''
    );

    parsedCourses!.forEach(course => {
      if (isComplete) {
        // prettier-ignore
        isComplete = (!visible.offerEvidence || !mandatory.offerEvidence || course.offerEvidence?.trim() !== '');
      }
    });

    return isComplete;
  };

  // prettier-ignore
  const complete = isCourseComplete();

  return {
    complete,
    visible,
    mandatory
  };
}
